import request from '../../utils/request';

export default {
  //获取专业关系列表
  academicPlanningList(params) {
    return request.get('api/academic-planning/plan-list', {params})
  },

  //查看学习路径
  academicPlanningCourse(params) {
    return request.get('api/academic-planning/user-search-class', {params})
  },

}